import React, { useContext } from "react";
import "../css/privacy.scss";
import PolicyPage from "./PolicyPage";
import { CartContext } from "./CartContext";

const sections = [
  {
    title: "What this demo stores",
    paragraphs: [
      "This front-end demonstration does not create an account or send gameplay data to an anackmira server. It uses your browser’s localStorage so the experience can persist after a refresh.",
    ],
    list: [
      "Cart items and selected digital editions",
      "Saved games and local best scores",
      "Demo order number, contact email and order total",
      "Which full-edition configurations are unlocked on this browser",
      "Your cookie and optional analytics preference",
    ],
  },
  {
    title: "Contact and form data",
    paragraphs: [
      "The checkout email is stored only inside the local demo order. The optional contact form saves its contents locally and explicitly does not send an email. Do not enter confidential or sensitive information.",
    ],
  },
  {
    title: "How local data is used",
    paragraphs: [
      "Local data restores the cart, favourites, gameplay progress, demo orders, unlock state and cookie preference. anackmira does not currently load advertising cookies or analytics services. Local data is not used to claim live player counts, global rankings, real purchases or cross-device access.",
    ],
  },
  {
    title: "Your choices",
    paragraphs: [
      "You can remove individual cart and favourite entries in the interface. The control below clears all anackmira demo data on this browser, including orders, scores and unlocks. Browser settings can also clear site storage.",
    ],
  },
  {
    title: "Future production review",
    paragraphs: [
      "If this demonstration later connects to analytics, payment, email or account services, this notice must be reviewed and updated before launch. Applicable rights and retention details depend on the final business and operating regions.",
    ],
  },
];

function Privacy() {
  const { clearLocalData } = useContext(CartContext);
  return (
    <PolicyPage
      kicker="Privacy"
      title="Your data stays close."
      summary="A plain-language description of the local browser data used by this demonstration."
      sections={sections}
    >
      <div className="data-control">
        <div>
          <h2>Clear local demo data</h2>
          <p>
            This immediately resets cart, favourites, scores, orders and unlocks
            on this browser.
          </p>
        </div>
        <button className="button button--quiet" onClick={clearLocalData}>
          Clear anackmira data
        </button>
      </div>
    </PolicyPage>
  );
}
export default Privacy;
